import { type RouterOutputs } from './trpc';

export type GetSessionsResponse = RouterOutputs['sessions']['get'];
export type Session = GetSessionsResponse['sessions'][0];

export enum BrowserNames {
  chrome = 'Chrome',
  firefox = 'Firefox',
  safari = 'Safari',
  opera = 'Opera',
  edge = 'Edge',
  unknown = 'Unknown',
  androidApp = 'Android App',
  androidBrowserChrome = 'Android Browser (Chrome)',
  androidBrowserFirefox = 'Android Browser (Firefox)',
  androidBrowserSamsung = 'Android Browser (Samsung)',
  androidBrowserOpera = 'Android Browser (Opera)',
  androidBrowserEdge = 'Android Browser (Edge)',
  iosApp = 'iOS App',
  iosBrowserSafari = 'iOS Browser (Safari)',
  iosBrowserChrome = 'iOS Browser (Chrome)',
  iosBrowserFirefox = 'iOS Browser (Firefox)',
  iosBrowserEdge = 'iOS Browser (Edge)',
  // Oakbox is a separate app against the same account, so it gets its own
  // session and its own name in the sessions list. Revoking one must not touch
  // the other, which is only true because they are different rows.
  oakboxIos = 'Oakbox (iOS)',
  oakboxAndroid = 'Oakbox (Android)',
  oakboxWeb = 'Oakbox (Web)'
}
